import React from 'react';
import PropTypes from 'prop-types';

import BookCard from 'components/cards/entities/BookCard';
import EventCard from 'components/cards/entities/EventCard';
import InstituteCard from 'components/cards/entities/InstituteCard';
import MovieCard from 'components/cards/entities/MovieCard';
import ObjectCard from 'components/cards/entities/ObjectCard';
import PersonCard from 'components/cards/entities/PersonCard';
import PoemCard from 'components/cards/entities/PoemCard';
import PromoBlockCard from 'components/cards/entities/PromoBlockCard';
import PublicationCard from 'components/cards/entities/PublicationCard';

const StyledContentEntities = ({ type, item, index, paramsImage }) => {
	switch (type) {
		case 'article':
		case 'theme':
			return <PublicationCard entity={item} params={paramsImage} cropText />;
		case 'book':
			return <BookCard entity={item} colorIndex={index} keepRatio cropText />;
		case 'event':
			return <EventCard entity={item} params={paramsImage} />;
		case 'institute':
			return <InstituteCard entity={item} params={paramsImage} />;
		case 'movie':
			return <MovieCard entity={item} params={paramsImage} />;
		case 'object':
			return <ObjectCard entity={item} params={paramsImage} />;
		case 'person':
			return <PersonCard entity={item} params={paramsImage} />;
		case 'poem':
			return <PoemCard entity={item} />;
		case 'promoBlock':
			return <PromoBlockCard entity={item} params={paramsImage} cropText />;
		default:
			return null;
	}
};

StyledContentEntities.propTypes = {
	type: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	index: PropTypes.number,
	paramsImage: PropTypes.object
};

export default StyledContentEntities;
